import React from 'react';

import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context';

import { type GlobalSideNavigationProps } from '../types';

import { COMPONENT_NAME } from './constants';
import {
	type PackageMetaDataType,
	type SideNavMetadataType,
	type SourceMetadataType,
} from './generated/analytics.types';

export function withSideNavigationAnalyticsContext<P extends GlobalSideNavigationProps>(
	WrappedComponent: React.ComponentType<P>,
): React.ComponentType<P> {
	return (props: P) => {
		const contextData: AnalyticsGlobalContextType = {
			...packageMetadata,
			attributes: {
				...sideNavMetadata,
				...sourceMetadata,
				screen: props.app || 'unknown',
			},
		};

		return (
			<NavigationAnalyticsContext data={contextData}>
				<WrappedComponent {...props} />
			</NavigationAnalyticsContext>
		);
	};
}

type AnalyticsGlobalContextType = PackageMetaDataType & {
	attributes: SourceMetadataType & SideNavMetadataType & {};
};

const packageMetadata: PackageMetaDataType = {
	source: 'topNav',
	componentName: COMPONENT_NAME,
	packageName: process.env._PACKAGE_NAME_ ?? '',
	packageVersion: process.env._PACKAGE_VERSION_ ?? '',
};

const sourceMetadata: SourceMetadataType = {
	navLayer: 'global',
	navContainer: 'top',
	navVersion: '4',
};

const sideNavMetadata: SideNavMetadataType = {
	screen: 'unknown',
	workspaceUuid: null,
};
